import type { AxiosError } from 'axios';
import type { PostAuthenticateInviteResponse } from '@bvengineering/cas-member-gateway-service-client';
import { useApiMutation } from '@/api/hooks/useMutation';

interface PostAuthenticateVariables {
  accessToken: string;
}

/** Validate existing creator link for standard sign-in (non-invite). */
export function usePostAuthenticate() {
  return useApiMutation<PostAuthenticateInviteResponse, AxiosError, PostAuthenticateVariables>({
    mutationFn:
      (api) =>
      async ({ accessToken }) => {
        const response = await api.auth.creatorsAuthControllerPostAuthenticate(
          `Bearer ${accessToken}`
        );
        if (!response.data.success) throw new Error('Creator validation did not complete');
        return response.data;
      },
  });
}
